import React, { useState, useEffect, useRef } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Navbar as BootstrapNavbar, NavDropdown, Container, Offcanvas } from 'react-bootstrap'
import './Navbar.css'
import Logo from '../Assets/Logo.jpg'
import { FiMinus, FiPlus } from 'react-icons/fi'
import SearchResults from './SearchResults'

const SCROLL_TO_TOP_PATHS = new Set([
  '/',
  '/organization',
  '/news-events',
  '/kham-chua-benh',
  '/kham-chua-benh/loai-hinh',
  '/kham-chua-benh/thanh-toan',
  '/kham-chua-benh/trang-thiet-bi',
  '/kham-chua-benh/cac-don-vi',
  '/thong-tin-chung/cac-don-vi',
  '/thong-tin-chung/thong-tin-duoc',
  '/thong-tin-chung/bao-hiem-y-te',
  '/thong-tin-chung/thu-chao-moi-san-pham',
])

const MOBILE_MENU_HOTLINE_DISPLAY = '0974.225.225'
const MOBILE_MENU_HOTLINE_TEL = '0974225225'
const MOBILE_MENU_BOOKING_PATH = '/book-appointment'

const Navbar = () => {
  const [activeMenu, setActiveMenu] = useState('#home')
  const [isScrolled, setIsScrolled] = useState(false)
  const [openDropdown, setOpenDropdown] = useState(null)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const [mobileExpandedKey, setMobileExpandedKey] = useState(null)
  const [searchTerm, setSearchTerm] = useState('')
  const [searchResults, setSearchResults] = useState([])
  const [showSearchResults, setShowSearchResults] = useState(false)
  const navbarRef = useRef(null)
  const searchRef = useRef(null)
  const latestSearchRef = useRef('')
  const location = useLocation()

  const menuItems = [
    { href: '/', label: 'Trang chủ', isRoute: true },
    { href: '/organization', label: 'Tổ chức bệnh viện', isRoute: true, isDropdown: true, dropdownKey: 'org' },
    { href: '/news-events', label: 'Tin tức - Sự kiện', isRoute: true },
    { href: '/kham-chua-benh', label: 'Khám chữa bệnh', isRoute: true, isDropdown: true, dropdownKey: 'kcb' },
    { href: '/party-politics', label: 'Công tác Đảng - Chính trị', isRoute: true, isDropdown: true, dropdownKey: 'party' },
    { href: '/duoc-pham-suc-khoe', label: 'Dược phẩm - Sức khoẻ', isRoute: true, isDropdown: true, dropdownKey: 'duoc' },
    { href: '/customer-guide', label: 'Dành cho khách hàng', isRoute: true },
    { href: '/thong-tin-chung', label: 'Thông tin chung', isRoute: false, isDropdown: true, dropdownKey: 'info' },
  ]

  const organizationItems = [
    { href: '/organization', label: 'Ban giám đốc bệnh viện' },
    { href: '/thong-tin-chung/thong-tin-benh-vien', label: 'Giới thiệu bệnh viện' },
    { href: '/thong-tin-chung/cac-don-vi', label: 'Giới thiệu các đơn vị' },
  ]

  const khamChuaBenhItems = [
    { href: '/kham-chua-benh', label: 'Quy trình khám chữa bệnh' },
    { href: '/kham-chua-benh/loai-hinh', label: 'Thủ tục xuất viện' },
    { href: '/kham-chua-benh/thanh-toan', label: 'Đăng ký khám theo yêu cầu' },
    { href: '/kham-chua-benh/trang-thiet-bi', label: 'Trang thiết bị' },
    { href: 'http://117.4.137.26:11664/?c=banggia', label: 'Bảng giá dịch vụ' },
  ]

  const partyItems = [
    { href: '/party-politics?tab=cong-tac-dang', label: 'Công tác Đảng' },
    { href: '/party-politics?tab=cong-tac-chinh-tri', label: 'Hoạt động kỷ niệm, tổ chức' },
    { href: '/party-politics?tab=lich-su-doi-moi', label: 'Lịch sử đổi mới' },
  ]

  const duocItems = [
    { href: '/duoc-pham-suc-khoe?tab=hop-tac-khoa-hoc', label: 'Dược lâm sàng' },
    { href: '/duoc-pham-suc-khoe?tab=cac-cuoc-thi', label: 'Hướng dẫn sử dụng thuốc' },
    { href: '/duoc-pham-suc-khoe?tab=don-vi-dong-hanh', label: 'Đơn vị đồng hành' },
  ]

  const infoItems = [

    { href: 'https://moh.gov.vn/cong-bo-thong-tin-lien-quan-den-linh-vuc-duoc', label: 'Thông tin dược' },
    { href: 'https://baohiemxahoi.gov.vn/tracuu/pages/tra-cuu-thoi-han-su-dung-the-bhyt.aspx', label: 'Thông tin bảo hiểm y tế' },
    { href: '/thong-tin-chung/thu-chao-moi-san-pham', label: 'Thư chào mời sản phẩm' },
    { href: 'https://web-thitracnghiem.vercel.app/', label: 'Thi trắc nghiệm' },
    { href: 'https://qlbv.benhvienqy4qk4.vn:8443/login', label: 'Chấm công bệnh viện' }
  ]

  useEffect(() => {
    if (location.pathname === '/') {
      setActiveMenu('/')
    }
  }, [location])


  useEffect(() => {
    if (SCROLL_TO_TOP_PATHS.has(location.pathname)) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }, [location.pathname])


  useEffect(() => {
    setIsMobileMenuOpen(false)
    setMobileExpandedKey(null)
  }, [location.pathname])


  useEffect(() => {
    if (!isMobileMenuOpen) setMobileExpandedKey(null)
  }, [isMobileMenuOpen])

  const handleDropdownItemClick = () => {

    setOpenDropdown(null)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const getScrollTarget = (href) => {
    if (!href) return null

    if (href.startsWith('#')) {
      try {
        return document.querySelector(href)
      } catch (error) {
        console.warn(`Invalid selector ${href}`, error)
        return null
      }
    }

    const normalizedId = href.replace(/^[#\\/]+/, '')
    if (!normalizedId) return null
    return document.getElementById(normalizedId)
  }

  const handleMenuClick = (event, item) => {
    if (item.isRoute) {

      if (item.href === location.pathname) {
        event.preventDefault()
        event.stopPropagation()
        setActiveMenu(item.href)
        window.scrollTo({ top: 0, behavior: 'smooth' })
        return false
      }

      setActiveMenu(item.href)
      return
    }

    event.preventDefault()
    setActiveMenu(item.href)
    const targetElement = getScrollTarget(item.href)
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  useEffect(() => {
    // Dùng IntersectionObserver thay cho scroll + getBoundingClientRect
    // để tránh forced reflow mỗi lần cuộn trang
    const el = navbarRef.current
    if (!el) return
    const observer = new IntersectionObserver(([entry]) => {
      setIsScrolled(!entry.isIntersecting && entry.boundingClientRect.bottom < 0)
    })
    observer.observe(el)
    return () => observer.disconnect()
  }, [])


  useEffect(() => {
    const handleClickOutside = (event) => {
      const target = event.target
      if (!target || typeof target.closest !== 'function') return

      const isClickOnDropdownToggle = target.closest('.custom-nav-dropdown .dropdown-toggle')
      if (isClickOnDropdownToggle) {

        return
      }

      const isClickOnDropdownMenu = target.closest('.dropdown-menu')
      if (isClickOnDropdownMenu) {
        const hasCustomItems = isClickOnDropdownMenu.querySelector('.custom-dropdown-item')
        if (hasCustomItems) {
          // Don't close when clicking on menu items
          return
        }
      }

      // Close if clicking outside
      setOpenDropdown(null)
    }

    if (openDropdown) {
      document.addEventListener('mousedown', handleClickOutside)
      return () => {
        document.removeEventListener('mousedown', handleClickOutside)
      }
    }
  }, [openDropdown])

  // Keep dropdown open when hovering over dropdown menu
  useEffect(() => {
    const handleDropdownMenuHover = (e) => {
      const target = e.target
      if (!target || typeof target.closest !== 'function') return

      const dropdownMenu = target.closest('.dropdown-menu')
      if (dropdownMenu) {
        const hasCustomItems = dropdownMenu.querySelector('.custom-dropdown-item')
        if (hasCustomItems && openDropdown) {
          // Keep it open when hovering over menu
          setOpenDropdown(openDropdown)
        }
      }
    }

    if (openDropdown) {
      document.addEventListener('mouseenter', handleDropdownMenuHover, true)
      return () => {
        document.removeEventListener('mouseenter', handleDropdownMenuHover, true)
      }
    }
  }, [openDropdown])

  const getMobileDropdownItems = (dropdownKey) => {
    if (dropdownKey === 'org') return organizationItems
    if (dropdownKey === 'kcb') return khamChuaBenhItems
    if (dropdownKey === 'party') return partyItems
    if (dropdownKey === 'duoc') return duocItems
    if (dropdownKey === 'info') return infoItems
    return []
  }

  const isItemActive = (href) => {
    if (href.startsWith('http')) return false
    const [path, query] = href.split('?')
    if (location.pathname !== path) return false
    if (!query) return true
    const tab = new URLSearchParams(query).get('tab')
    const currentTab = new URLSearchParams(location.search).get('tab')
    return tab === (currentTab || (path === '/party-politics' ? 'cong-tac-dang' : 'hop-tac-khoa-hoc'))
  }

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false)
    setMobileExpandedKey(null)
  }

  const handleMobileLeafClick = () => {
    closeMobileMenu()
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  // Search functionality
  const handleSearchChange = (e) => {
    const value = e.target.value
    setSearchTerm(value)
    latestSearchRef.current = value

    if (value.trim().length >= 2) {
      // Tải dữ liệu tìm kiếm theo yêu cầu (tách khỏi bundle chính)
      Promise.all([
        import('../../utils/searchData'),
        import('../../utils/globalSearch')
      ]).then(([{ getAllSearchableData }, { searchAndSort }]) => {
        // Bỏ qua nếu người dùng đã gõ tiếp
        if (latestSearchRef.current !== value) return
        const allData = getAllSearchableData()
        const results = searchAndSort(allData, value, 5)
        setSearchResults(results)
        setShowSearchResults(true)
      })
    } else {
      setSearchResults([])
      setShowSearchResults(false)
    }
  }

  const handleSearchFocus = () => {
    if (searchTerm.trim().length >= 2 && searchResults.length > 0) {
      setShowSearchResults(true)
    }
  }

  const handleCloseSearch = () => {
    setShowSearchResults(false)
  }

  // Click outside to close search results
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSearchResults(false)
      }
    }

    if (showSearchResults) {
      document.addEventListener('mousedown', handleClickOutside)
      return () => {
        document.removeEventListener('mousedown', handleClickOutside)
      }
    }
  }, [showSearchResults])

  // Clear search when navigating
  useEffect(() => {
    setSearchTerm('')
    setSearchResults([])
    setShowSearchResults(false)
  }, [location.pathname])

  return (
    <>
      {/* Mobile Bootstrap Navbar - Only visible on mobile */}
      <BootstrapNavbar
        bg="white"
        variant="light"
        expand={false}
        className="mobile-navbar-bootstrap"
        fixed="top"
      >
        <Container fluid>
          <BootstrapNavbar.Brand as={Link} to="/">
            <img
              src={Logo}
              width="63"
              height="50"
              className="d-inline-block align-top"
              alt="Logo"
            />
          </BootstrapNavbar.Brand>
          <div className="position-absolute start-50 translate-middle-x d-flex flex-column justify-content-center align-items-center text-center text-success">
            <span className="fw-bold" style={{ fontSize: '13px', lineHeight: '1.2', whiteSpace: 'nowrap' }}>BỆNH VIỆN QUÂN Y 4</span>
          </div>
          <BootstrapNavbar.Toggle
            aria-label="Open menu"
            onClick={() => setIsMobileMenuOpen(true)}
          />
        </Container>
      </BootstrapNavbar>

      {/* Mobile Drawer Menu (Offcanvas) */}
      <Offcanvas
        show={isMobileMenuOpen}
        onHide={closeMobileMenu}
        placement="start"
        className="mobile-drawer"
        backdrop
        scroll={false}
      >
        <Offcanvas.Header closeButton />
        <Offcanvas.Body>
          <div className="mobile-drawer-body">
            <ul className="mobile-menu">
              {menuItems.map((item) => {
                const isExpanded = mobileExpandedKey === item.dropdownKey
                const isDropdown = Boolean(item.isDropdown)

                if (!isDropdown) {
                  const isExternal = item.href.startsWith('http')
                  return (
                    <li key={item.href} className="mobile-menu-item">
                      {isExternal ? (
                        <a
                          className="mobile-menu-row"
                          href={item.href}
                          target="_blank"
                            rel="noopener noreferrer"
                          onClick={handleMobileLeafClick}
                        >
                          <span className="mobile-menu-label">{item.label}</span>
                        </a>
                      ) : (
                        <Link
                          className="mobile-menu-row"
                          to={item.href}
                          onClick={handleMobileLeafClick}
                        >
                          <span className="mobile-menu-label">{item.label}</span>
                        </Link>
                      )}
                    </li>
                  )
                }

                return (
                  <li key={item.href} className="mobile-menu-item">
                    <button
                      type="button"
                      className="mobile-menu-row mobile-menu-row--toggle"
                      aria-expanded={isExpanded}
                      onClick={() =>
                        setMobileExpandedKey(isExpanded ? null : item.dropdownKey)
                      }
                    >
                      <span className="mobile-menu-label">{item.label}</span>
                      <span className="mobile-menu-icon" aria-hidden="true">
                        {isExpanded ? <FiMinus /> : <FiPlus />}
                      </span>
                    </button>

                    {isExpanded && (
                      <div className="mobile-submenu">
                        {getMobileDropdownItems(item.dropdownKey).map((subItem) => {
                          const isExternal = subItem.href.startsWith('http')
                          const isActive = isItemActive(subItem.href)
                          return isExternal ? (
                            <a
                              key={subItem.href}
                              className={`mobile-submenu-link ${isActive ? 'active' : ''}`}
                              href={subItem.href}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={handleMobileLeafClick}
                            >
                              {isActive && <span className="star-icon">⭐ </span>}
                              {subItem.label}
                            </a>
                          ) : (
                            <Link
                              key={subItem.href}
                              className={`mobile-submenu-link ${isActive ? 'active' : ''}`}
                              to={subItem.href}
                              onClick={handleMobileLeafClick}
                            >
                              {isActive && <span className="star-icon">⭐ </span>}
                              {subItem.label}
                            </Link>
                          )
                        })}
                      </div>
                    )}
                  </li>
                )
              })}
            </ul>

            <div className="mobile-drawer-footer">
              <a
                className="mobile-drawer-btn mobile-drawer-btn--outline"
                href={`tel:${MOBILE_MENU_HOTLINE_TEL}`}
                onClick={closeMobileMenu}
              >
                Gọi tổng đài {MOBILE_MENU_HOTLINE_DISPLAY}
              </a>
              <Link
                className="mobile-drawer-btn mobile-drawer-btn--solid"
                to={MOBILE_MENU_BOOKING_PATH}
                onClick={handleMobileLeafClick}
              >
                Đặt lịch khám
              </Link>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      {/* Desktop Navbar - Unchanged, hidden on mobile */}
      <div className="navbar" ref={navbarRef}>
        <div className="top-strip">
          <div className="location-text">Đường Lê Viết Thuật, Phường Vinh Lộc, Tỉnh Nghệ An</div>
          <div className="quick-actions">
            <a href="tel:0974225225" className="btn btn-outline">Gọi tổng đài</a>
            <Link to="/book-appointment" className="btn btn-outline">Đặt lịch khám</Link>
          </div>
        </div>

        <div className="navbar-top">
          <div className="logo-wrap">
            <Link to="/">
              <img src={Logo} alt="Logo" width="404" height="320" />
            </Link>
          </div>

          <div className="title-wrap">
            <div className="title-vi">
              BỆNH VIỆN QUÂN Y 4<span className="title-separator"> - </span>CỤC HẬU CẦN KỸ THUẬT QUÂN KHU 4
            </div>
          </div>

          <div className="actions-wrap">
            <div className="flags-slot" aria-label="Cờ Đảng và cờ Tổ quốc">
              <span className="header-flag party-flag" role="img" aria-label="Cờ Đảng">
                <span aria-hidden="true">☭</span>
              </span>
              <span className="header-flag national-flag" role="img" aria-label="Cờ Tổ quốc Việt Nam">
                <span aria-hidden="true">★</span>
              </span>
            </div>
            <div className="search-box" ref={searchRef}>
              <input
                placeholder="Tìm kiếm............"
                value={searchTerm}
                onChange={handleSearchChange}
                onFocus={handleSearchFocus}
              />
              <span className="icon">| 🔍</span>
              {showSearchResults && (
                <SearchResults
                  results={searchResults}
                  onClose={handleCloseSearch}
                  searchTerm={searchTerm}
                />
              )}
            </div>
          </div>
        </div>

        <div className="navbar-menu">
          {menuItems.map(item => (
            item.isDropdown ? (
              <NavDropdown
                key={item.href}
                title={item.label}
                id={`${item.dropdownKey}-dropdown`}
                menuVariant="dark"
                className="custom-nav-dropdown"
                show={openDropdown === item.dropdownKey}
                onToggle={(isOpen) => setOpenDropdown(isOpen ? item.dropdownKey : null)}
                popperConfig={{
                  modifiers: [
                    {
                      name: 'preventOverflow',
                      options: {
                        boundary: 'viewport',
                      },
                    },
                    {
                      name: 'flip',
                      enabled: false,
                    },
                  ],
                }}
              >
                {getMobileDropdownItems(item.dropdownKey).map(dropdownItem => {
                  const isActive = isItemActive(dropdownItem.href)
                  return (
                    <NavDropdown.Item
                      key={dropdownItem.href}
                      as={dropdownItem.href.startsWith('http') ? 'a' : Link}
                      to={dropdownItem.href.startsWith('http') ? undefined : dropdownItem.href}
                      href={dropdownItem.href.startsWith('http') ? dropdownItem.href : undefined}
                      target={dropdownItem.href.startsWith('http') ? '_blank' : undefined}
                      rel={dropdownItem.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                      className={`custom-dropdown-item ${isActive ? 'active' : ''}`}
                      onClick={handleDropdownItemClick}
                    >
                      {isActive && <span className="star-icon">⭐</span>}
                      {dropdownItem.label}
                    </NavDropdown.Item>
                  )
                })}
              </NavDropdown>
            ) : item.isRoute ? (
              <Link
                key={item.href}
                to={item.href}
                className={location.pathname === item.href ? 'active' : ''}
                onClick={event => handleMenuClick(event, item)}
              >
                {item.label}
              </Link>
            ) : (
              <a
                key={item.href}
                href={item.href}
                className={activeMenu === item.href ? 'active' : ''}
                onClick={event => handleMenuClick(event, item)}
              >
                {item.label}
              </a>
            )
          ))}
        </div>
      </div>
      {isScrolled && (
        <div className="navbar-menu fixed-menu">
          {menuItems.map(item => (
            item.isDropdown ? (
              <NavDropdown
                key={item.href}
                title={item.label}
                id={`${item.dropdownKey}-dropdown-fixed`}
                menuVariant="dark"
                className="custom-nav-dropdown"
                show={openDropdown === item.dropdownKey}
                onToggle={(isOpen) => setOpenDropdown(isOpen ? item.dropdownKey : null)}
                popperConfig={{
                  modifiers: [
                    {
                      name: 'preventOverflow',
                      options: {
                        boundary: 'viewport',
                      },
                    },
                    {
                      name: 'flip',
                      enabled: false,
                    },
                  ],
                }}
              >
                {getMobileDropdownItems(item.dropdownKey).map(dropdownItem => {
                  const isActive = isItemActive(dropdownItem.href)
                  return (
                    <NavDropdown.Item
                      key={dropdownItem.href}
                      as={dropdownItem.href.startsWith('http') ? 'a' : Link}
                      to={dropdownItem.href.startsWith('http') ? undefined : dropdownItem.href}
                      href={dropdownItem.href.startsWith('http') ? dropdownItem.href : undefined}
                      target={dropdownItem.href.startsWith('http') ? '_blank' : undefined}
                      rel={dropdownItem.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                      className={`custom-dropdown-item ${isActive ? 'active' : ''}`}
                      onClick={handleDropdownItemClick}
                    >
                      {isActive && <span className="star-icon">⭐</span>}
                      {dropdownItem.label}
                    </NavDropdown.Item>
                  )
                })}
              </NavDropdown>
            ) : item.isRoute ? (
              <Link
                key={item.href}
                to={item.href}
                className={location.pathname === item.href ? 'active' : ''}
                onClick={event => handleMenuClick(event, item)}
              >
                {item.label}
              </Link>
            ) : (
              <a
                key={item.href}
                href={item.href}
                className={activeMenu === item.href ? 'active' : ''}
                onClick={event => handleMenuClick(event, item)}
              >
                {item.label}
              </a>
            )
          ))}
        </div>
      )}
    </>
  )
}

export default Navbar
